<template>
    <v-btn flat @click="onClick" small color="error">
    <v-icon>cancel</v-icon>
    {{translater.__('Cancel')}}
    </v-btn>
</template>

<script>
    export default {
        name: 'ErrorButton',
        props: ['onClick'],
        computed: {
            translater: {
                get()
                {
                    return this.$store.getters['translate/translater'];
                }
            }
        }
    }
</script>